import { zoomStyle, semanticZoom } from "./semantic-zoom.js";
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
export function smoothstep(value) { const t = clamp(value, 0, 1); return t * t * (3 - 2 * t); }

// Distinct neighbors, not evidence count or parallel edge count. This measures
// connectedness in the collected graph, never fame or real-world influence.
export function rankImportance(graph, communities) {
  const ranked = graph.mapNodes(id => ({ id, degree: graph.neighbors(id).length }));
  ranked.sort((a, b) => b.degree - a.degree || a.id.localeCompare(b.id));
  const maxDegree = Math.max(1, ranked[0]?.degree || 0);
  const landmarks = new Set();
  const result = new Map(ranked.map((node, rank) => [node.id, { ...node, rank, minLabelZoom: rank < 5 ? -.6 : .8 + 3 * Math.pow(rank / Math.max(1, ranked.length - 1), .4), importance: Math.pow(node.degree / maxDegree, .55) }]));
  for (const [id, rank] of result) { const group = communities?.get(id); if (group && group.members.length >= 8 && !landmarks.has(group.id)) { landmarks.add(group.id); rank.landmark = true; rank.minLabelZoom = Math.min(rank.minLabelZoom, .8); } }
  return result;
}

export function labelAppearance({ importance, localRank, zoom = 1, mobile = false, priority = false, landmark = false, labelSize = 10, candidateCount = 0 }) {
  const z = semanticZoom(zoom, 1), lod = zoomStyle(z, mobile);
  const scale = clamp(labelSize / 14, .95, 1.08);
  const fontSize = clamp((13 + 4 * importance + lod.fontGrowth) * scale, 13, 22);
  const quota = lod.labelQuota + candidateCount * lod.labelSaturation;
  const reveal = smoothstep((quota - localRank) / Math.max(2, quota * .3));
  return { fontSize: priority ? Math.max(mobile ? 14 : 15, fontSize) : fontSize,
    weight: priority || landmark || importance >= .45 ? 600 : 500, opacity: priority ? 1 : reveal * (.86 + .12 * importance), quota };

}

export function approachOpacity(current, target, elapsed, reducedMotion = false) {
  if (reducedMotion || Math.abs(target - current) < .008) return target;
  return current + (target - current) * (1 - Math.exp(-Math.min(64, elapsed) / 110));
}
